import 'bootstrap-notify';

var notify = function(type, title, message) {
	$.notify({
		title: title,
		message: message
	}, {
		newest_on_top: true,
		placement: {
			from: 'top',
			align: 'center'
		},
		mouse_over: 'pause',
		type: type,
		template: '<div data-notify="container" class="col-11 col-sm-7 alert alert-{0}" role="alert"><button type="button" aria-hidden="true" class="btn-close mt-2" data-notify="dismiss"></button><span data-notify="icon"></span> <strong data-notify="title">{1}</strong> <span data-notify="message">{2}</span><div class="progress" data-notify="progressbar"><div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" class="w-0"></div></div><a href="{3}" target="{4}" data-notify="url"></a></div>'
	});
};

export default notify;
